import type { IErrorCaptureContext, IErrorProvider, IErrors } from './types';

export function createErrors(provider: IErrorProvider): IErrors {
  return {
    capture(error: unknown, context?: IErrorCaptureContext) {
      provider.capture(error, context);
    },
  };
}
